'use strict';

var React = require('react'),
    host = 'https://nocache.thum.io';
//	getThumURL = require('thum.io').getThumURL;

var CommandBuilder = React.createClass({
	displayName: 'CommandBuilder',

	getInitialState: function getInitialState() {
		return {
			url: 'http://',
			command: '[]',
			fullpage: false,
			formAction: host + '/get/http://'
		};
	},

	render: function render() {
		return React.createElement(
			'div',
			{ className: 'command-builder-container' },
			React.createElement(
				'p',
				null,
				React.createElement(
					'form',
					{ action: this.state.formAction, method: 'post', target: 'viewFrame' },
					React.createElement(
						'label',
						{ style: { width: '100px' }, htmlFor: 'url' },
						'URL:'
					),
					React.createElement('input', { size: '50', id: 'url', type: 'text', value: this.state.url, onChange: this.updateUrl }),
					React.createElement('br', null),
					React.createElement(
						'label',
						{ style: { width: '100px' }, htmlFor: 'fullpage' },
						'Full-page:'
					),
					React.createElement('input', { id: 'fullpage', type: 'checkbox', onChange: this.updateFullpage }),
					React.createElement('br', null),
					React.createElement(
						'textarea',
						{ cols: '80', rows: '10', name: 'commands', onChange: this.updateCommand },
						this.state.command
					),
					React.createElement('br', null),
					React.createElement('input', { type: 'submit' }),
					React.createElement('br', null),
					React.createElement(
						'label',
						{ style: { width: '100px' } },
						'Thum.io URL:'
					),
					' http:',
					this.state.screenshotURL,
					React.createElement('br', null)
				)
			),
			React.createElement(
				'p',
				null,
				React.createElement('iframe', { name: 'viewFrame', src: host + '/get/http://www.google.com/', style: {
						paddingTop: '20px',
						paddingBottom: '20px',
						textAlign: 'center',
						height: '650px',
						width: '650px',
						overflow: 'auto',
						backgroundColor: '#cccccc' } })
			)
		);
	},

	setUrl: function setUrl(e) {
		e.preventDefault();

		console.log('setUrl', this.state.url);
		var newUrl = this.state.url;
		if (newUrl.indexOf('http') !== 0) {
			newUrl = 'http://' + newUrl;
		}
		this.setState({ screenshotURL: '/spinners/0.gif',
			url: newUrl, formAction: host + '/get/' + newUrl });
	},
	postLoad: function postLoad(e) {
		console.log('postload');
		console.log('  fullpage', this.state.fullpage);
		var fullpage = '';
		if (this.state.fullpage) {
			console.log('  loading fullpage');
			fullpage = 'fullpage/';
		}
		this.setState({ screenshotURL: host + '/get/png/width/1200/' + fullpage + this.state.url });
	},
	updateUrl: function updateUrl(e) {
		console.log('url=', e.target.value);
		var newUrl = e.target.value;
		this.setState({
			url: newUrl,
			formAction: host + '/get/' + newUrl
		});
	},
	updateCommand: function updateCommand(e) {
		console.log('command=', e.target.value);
		var newCommand = e.target.value;
		this.setState({ command: newCommand });
	},
	updateFullpage: function updateFullpage(e) {
		console.log('fullpage', e.target.checked);
		this.setState({ fullpage: e.target.checked });
	}
});

module.exports = CommandBuilder;


//////////////////
// WEBPACK FOOTER
// ./client/components/CommandBuilder.js
// module id = 419
// module chunks = 0